import React, { useEffect, useState } from 'react';
import { MdChevronLeft, MdChevronRight, MdFirstPage, MdLastPage } from 'react-icons/md';

type PaginationProps = {
  totalItems: number;
  itemsPerPageOptions?: number[];
  defaultItemsPerPage?: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
  setItemsPerPage: (itemsPerPage: number) => void;
};

const NewPagination: React.FC<PaginationProps> = ({
  totalItems,
  itemsPerPageOptions = [10, 25, 50, 100],
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const [inputValue, setInputValue] = useState(currentPage);

  useEffect(() => {
    setInputValue(currentPage);
  }, [currentPage]);

  useEffect(() => {
    const newTotalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    if (currentPage > newTotalPages) {
      setCurrentPage(1);
    }
  }, [itemsPerPage, totalItems, currentPage, setCurrentPage]);

  const goToPage = (page: number) => {
    const clampedPage = Math.max(1, Math.min(page, totalPages));

    setCurrentPage(clampedPage);
  };

  const handleItemsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = parseInt(e.target.value, 10);

    setItemsPerPage(newSize);
  };

  return (
    <div className="relative w-full h-auto p-4">
      <div className="flex flex-row gap-4 items-center justify-between">
        <div className='flex flex-row gap-2 items-center'>
          <span>Items per page</span>
          <select
            className="select select-bordered select-primary w-20 select-sm"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}>
            {itemsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      
        {/* Pagination */}
        <div className="flex justify-center items-center gap-2">
        <button className="btn btn-outline btn-primary btn-sm" onClick={() => goToPage(1)} disabled={currentPage === 1}>
          <MdFirstPage />
        </button>

        <button
          className="btn btn-outline btn-primary btn-xs"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}>
          <MdChevronLeft />
        </button>

        <span>Page </span>
        <input
          type="number"
          className="input input-bordered input-primary input-sm w-16 text-center no-spinner"
          value={inputValue}
          onChange={(e) => setInputValue(parseInt(e.target.value, 10))}
          onBlur={() => goToPage(inputValue)}
          min={1}
          max={totalPages}
        />
        <span>of {totalPages}</span>

        <button
          className="btn btn-outline btn-primary btn-xs"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}>
          <MdChevronRight />
        </button>

        <button
          className="btn btn-outline btn-primary btn-sm"
          onClick={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}>
          <MdLastPage />
        </button>
      </div>
        <div className=''>
          <span>
            Showing {startItem} - {endItem} of {totalItems} items
          </span>
        </div>
      </div>

      
    </div>
  );
};

export default NewPagination;
